module.exports = __webpack_public_path__ + "assets/img/img218.48b19d75.png";